import restClient from "../restClient";

export const getLocations = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    // Örnek endpoint, backend'e göre güncellenebilir
    const response = await restClient.get(`inventory-locations`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};


export const createLocation = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`inventory-locations`, {data:data}, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const deleteLocation = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`inventory-locations/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const updateLocation = async (id, data) => {

  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`inventory-locations/${id}`, {data: data}, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
}; 